<template>
  <el-card>
    <el-form class="reverse-form-full" :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top"
      label-width="120px">
      <el-row :gutter="12">
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item :label="$t('autorizacao')" prop="authorization" class="is-required">
            <el-input :maxlength="limits.authorization" show-word-limit :placeholder="$t('numero')" ref="authorization"
              v-on:keyup.native.enter="$refs.name.$el.getElementsByTagName('input')[0].focus()"
              v-model="ruleForm.authorization"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="10">
          <el-form-item :label="$t('nome')" prop="name">
            <el-input :maxlength="limits.name" show-word-limit :placeholder="$t('nome')" ref="name"
              v-on:keyup.native.enter="$refs.cpfcnpj.$el.getElementsByTagName('input')[0].focus()"
              v-model="ruleForm.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item :label="$t('cpf/cnpj')" prop="cpfcnpj">
            <el-input :maxlength="limits.cpfcnpj" placeholder="CPF ou CNPJ" ref="cpfcnpj"
              v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']"
              v-on:keyup.native.enter="$refs.content.$el.getElementsByTagName('textarea')[0].focus()"
              v-model="ruleForm.cpfcnpj"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('conteudo')" prop="content">
            <el-input type="textarea" :rows="2" :maxlength="limits.content" show-word-limit
              placeholder="Observações ou descrição" ref="content" v-model="ruleForm.content"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="bottom clearfix">
        <el-button type="success" v-on:click="add">Adicionar</el-button>
      </div>
    </el-form>
    <el-table :data="tableList" size="small" stripe>
      <el-table-column sortable prop="authorization" :label="$t('autorizacao')" width="140" show-overflow-tooltip />
      <el-table-column sortable prop="name" :label="$t('nome')" min-width="100" show-overflow-tooltip />
      <el-table-column sortable prop="cpfcnpj" :label="$t('cpf/cnpj')" width="150" show-overflow-tooltip />
      <el-table-column prop="content" :label="$t('conteudo')" min-width="160" show-overflow-tooltip />
    </el-table>
  </el-card>
</template>

<script>
import { CnpjHelpers } from "@/xpost/helpers/cnpj";
import { CpfHelpers } from "@/xpost/helpers/cpf";

const LIMITS = {
  authorization: 13,
  name: 50,
  cpfcnpj: 18,
  content: 200,
};

export default {
  name: "PdvCallReverse",
  methods: {
    defaultRuleForm() {
      return {
        authorization: "",
        name: "",
        cpfcnpj: "",
        content: "",
      };
    },
    startup(form) {
      this.ruleForm = { ...this.defaultRuleForm(), ...(form || {}) };
    },
    focus() {
      setTimeout(() => {
        this.$refs.authorization.$el.getElementsByTagName('input')[0].focus();
      }, 200);
    },
    clear() {
      this.tableList = [];
      this.ruleForm = this.defaultRuleForm();
      if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate();
    },
    remove(index, authorization) {
      const vm = this;
      vm.tableList.splice(index, 1);
    },
    checkCpfCnpj(rule, value, callback) {
      if (!value) return callback();
      const document = String(value).replace(/[^0-9A-Za-z]/g, "");
      if (document.length === 11) {
        return CpfHelpers.validate(value) ? callback() : callback(new Error(this.$t("cpf-invalido")));
      }
      if (document.length === 14) {
        return CnpjHelpers.validate(value) ? callback() : callback(new Error(this.$t("cnpj-invalido")));
      }
      return callback(new Error(document.length < 14 ? this.$t("cpf-invalido") : this.$t("cnpj-invalido")));
    },
    add() {
      const vm = this;
      const row = {
        authorization: String(vm.ruleForm.authorization || "").trim(),
        name: String(vm.ruleForm.name || "").trim(),
        cpfcnpj: String(vm.ruleForm.cpfcnpj || "").trim(),
        content: String(vm.ruleForm.content || "").trim(),
      };
      if (!row.authorization) {
        this.$message({ type: "error", message: "É preciso informar o número da autorização!", offset: 45 });
        vm.$refs.authorization.$el.getElementsByTagName('input')[0].focus();
        return false;
      }
      const authorizationData = vm.tableList.find(x => x.authorization === row.authorization);
      if (authorizationData) {
        this.$message({ type: "error", message: "Autorização já informada!", offset: 45 });
        return false;
      }
      vm.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.$message({ type: "error", message: "Verifique os campos informados!", offset: 45 });
          return false;
        }
        vm.$bus.$emit("pdv.created", {
          ...row,
          type: 'reverse',
        });
        vm.tableList.push(row);
        vm.ruleForm = vm.defaultRuleForm();
        vm.$refs.ruleForm.clearValidate();
        vm.$refs.authorization.$el.getElementsByTagName('input')[0].focus();

        this.$message({
          type: "success",
          message: "Autorização registrada com sucesso!",
          offset: 45,
        });
      });
    },
  },
  data() {
    return {
      limits: LIMITS,
      rules: {
        cpfcnpj: [{ validator: this.checkCpfCnpj, trigger: "blur" }],
      },
      ruleForm: {
        authorization: "",
        name: "",
        cpfcnpj: "",
        content: "",
      },
      tableList: [],
    };
  },
}
</script>